import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { OtpTextInput } from "share/atoms/form-fields";
import VerifyLogo from "assets/deletion/verify.svg";
import {
  ModalHeader,
  ModalTag,
  Counter,
  ErrorText,
  ResendButton,
  CheckBox,
  HyperLink,
  SubmitButton,
} from "./styles";
import Timer from "share/atoms/Timer";
import { FaCheckSquare, FaRegSquare } from "react-icons/fa";
import { hideMobileNumber, onlineDecorator } from "utils/helpers";
import AccountDeletionService from "./service";
import notify from "utils/notifications";
import { useSession } from "share/hooks";

function VerificationBlock({ phoneNumber, handleVerify, handleClose }) {
  const accountDeletionService = new AccountDeletionService();
  const [setOTPSession, getOTPSession, removeOTPSession] =
    useSession("cnaps_otp");
  const [setAcceptSession, getAcceptSession, removeAcceptSession] =
    useSession("pp_accept");
  const [value, setValue] = useState("");
  const [enableResend, setEnableResend] = useState(false);
  const [isAcceptPolicy, setIsAcceptPolicy] = useState(false);
  const [error, setIsError] = useState(false);
  const [isEnableVerify, setIsEnableVerify] = useState(false);

  const handleChange = (e) => {
    setValue(e);
    setOTPSession(e);
    setIsError(false);
  };
  const isDisabled = () => {
    let seconds = sessionStorage.getItem("otp-sec");
    if ((seconds && seconds > 0) || !seconds) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    setEnableResend(isDisabled());
    return () => {
      sessionStorage.removeItem("otp-sec");
    };
  }, []);
  useEffect(() => {
    try {
      const cnaps_otp = getOTPSession();
      const acceptPP = getAcceptSession();
      if (cnaps_otp) {
        setValue(cnaps_otp);
      }
      setIsAcceptPolicy(acceptPP);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const timerStatus = () => {
    setEnableResend(true);
  };
  const handleResend = async () => {
    const res = await accountDeletionService.postSendOTP();
    if (res.data.status === "success") {
      sessionStorage.setItem("otp-sec", 60);
      setEnableResend(false);
      setValue("");
      setIsError(false);
      removeOTPSession();
    } else {
      notify("error", res.data.message);
    }
  };

  const handleVerifyOTPAccount = async () => {
    try {
      if (value.length === 4) {
        const reqBody = {
          otp: value,
        };
        const res = await accountDeletionService.postValidateOTP(reqBody);
        if (res?.data?.status === "success") {
          removeOTPSession();
          removeAcceptSession();
          handleVerify(value);
        } else {
          setValue("");
          setIsError(true);
        }
      }
    } catch (error) {
      notify("error", error.message);
    }
  };

  useEffect(() => {
    if (value.length === 4 && isAcceptPolicy) {
      setIsEnableVerify(true);
    } else {
      setIsEnableVerify(false);
    }
  }, [value, isAcceptPolicy]);

  const seconds = sessionStorage.getItem("otp-sec");

  const handleVerifyOTP = onlineDecorator(handleVerifyOTPAccount, "otp");

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {/* <img src={VerifyLogo} alt="verify" /> */}
        <VerifyIcon />
        <ModalHeader style={{ paddingTop: "16px" }}>Verify OTP</ModalHeader>
        <ModalTag>
          Please enter OTP sent to your registered mobile number
          <ModalTag
            style={{ fontWeight: 600, color: "#242424", display: "inline" }}
          >
            {" "}
            {hideMobileNumber(phoneNumber)}
          </ModalTag>
        </ModalTag>

        <div style={{ margin: "40px 0 24px 0" }}>
          <Timer
            seconds={seconds}
            startTimer={enableResend}
            timerCompleted={timerStatus}
            hasWarning={true}
          />
        </div>
        <OtpTextInput inputLength={4} handleChange={handleChange} otp={value} />
        {error && (
          <ErrorText style={{ marginTop: "16px" }}>
            Incorrect OTP entered. Please try again.
          </ErrorText>
        )}
        <ResendButton
          $isValid={enableResend}
          onClick={enableResend ? handleResend : undefined}
        >
          Resend OTP
        </ResendButton>
        <AcceptPolicy
          handelAccept={() => {
            setIsAcceptPolicy((prev) => !prev);
            setAcceptSession(!isAcceptPolicy);
          }}
          isAcceptPolicy={isAcceptPolicy}
          handleClose={handleClose}
        />
      </div>
      <SubmitButton
        $isValid={isEnableVerify}
        style={{ width: "100%", marginTop: "24px" }}
        onClick={isEnableVerify ? handleVerifyOTP : undefined}
      >
        Verify
      </SubmitButton>
    </>
  );
}

export default VerificationBlock;

const AcceptPolicy = ({ isAcceptPolicy, handelAccept, handleClose }) => {
  const history = useHistory();
  return (
    <>
      <div style={{ fontSize: "12px" }}>
        <span
          style={{ marginRight: "10px", cursor: "pointer" }}
          onClick={handelAccept}
        >
          {isAcceptPolicy ? (
            <FaCheckSquare size={16} />
          ) : (
            <FaRegSquare size={16} />
          )}
        </span>
        I accept to the
        <HyperLink onClick={() => history.push("/terms-conditions")}>
          Terms & Conditions
        </HyperLink>
        &<HyperLink onClick={handleClose}>Privacy Policy</HyperLink>
      </div>
    </>
  );
};

const VerifyIcon = () => {
  return (
    <svg
      width="144"
      height="96"
      viewBox="0 0 144 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#6n2uf8irga)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.987 50.889V37.444c0-4.522 2.406-8.703 6.313-10.979l12.704-7.394a12.707 12.707 0 0 1 12.78 0l12.705 7.394a12.704 12.704 0 0 1 6.316 10.98v13.444c0 4.522-2.406 8.703-6.313 10.979l-12.704 7.394a12.708 12.708 0 0 1-12.78 0l-12.705-7.394a12.703 12.703 0 0 1-6.316-10.98z"
          fill="#D71A63"
        />
        <path
          d="M75.396 44.167V31.462m-.003 22.586a.702.702 0 0 0-.703.706.706.706 0 0 0 1.412 0 .706.706 0 0 0-.709-.706z"
          stroke="#fff"
          stroke-width="6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.937 66.216h.828a.362.362 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.362.362 0 0 1-.361-.361v-.828a.36.36 0 0 1 .361-.362zm2.872 0h.828a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.828a.363.363 0 0 1-.362-.361v-.828a.362.362 0 0 1 .361-.362zm2.873 0h.828a.363.363 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.362.362 0 0 1-.361-.361v-.828a.36.36 0 0 1 .36-.362zm2.871 0h.829a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.829a.363.363 0 0 1-.363-.361v-.828a.366.366 0 0 1 .363-.362zm2.872 0h.828a.363.363 0 0 1 .364.362v.828a.362.362 0 0 1-.364.361h-.828a.362.362 0 0 1-.361-.361v-.828a.363.363 0 0 1 .361-.362zm-8.511 3.131h.828a.363.363 0 0 1 .361.362v.83a.363.363 0 0 1-.36.361h-.83a.362.362 0 0 1-.36-.361v-.829a.362.362 0 0 1 .36-.363zm2.871 0h.829a.363.363 0 0 1 .361.362v.83a.364.364 0 0 1-.361.361h-.829a.363.363 0 0 1-.361-.361v-.829a.362.362 0 0 1 .361-.363zm2.872 0h.828a.363.363 0 0 1 .363.362v.83a.363.363 0 0 1-.363.361h-.828a.363.363 0 0 1-.361-.361v-.829a.363.363 0 0 1 .361-.363zm-2.975-6.495h.828a.363.363 0 0 1 .362.362v.828a.362.362 0 0 1-.362.361h-.828a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .36-.36zm2.871 0h.829a.363.363 0 0 1 .361.362v.828a.362.362 0 0 1-.361.361h-.829a.363.363 0 0 1-.363-.36v-.83a.365.365 0 0 1 .363-.36zm62.172-43.498h.828a.363.363 0 0 1 .362.361v.828a.36.36 0 0 1-.362.362h-.828a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.828a.365.365 0 0 1-.362-.362v-.828a.365.365 0 0 1 .362-.361zm2.873 0h.828a.365.365 0 0 1 .362.361v.828a.36.36 0 0 1-.362.362h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.871 0h.829a.364.364 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.362.362 0 0 1-.363-.362v-.828a.365.365 0 0 1 .363-.361zm2.872 0h.828a.365.365 0 0 1 .364.361v.828a.366.366 0 0 1-.225.335.362.362 0 0 1-.139.027h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm-8.511 3.13h.828a.365.365 0 0 1 .362.361v.831a.365.365 0 0 1-.362.362h-.828a.366.366 0 0 1-.362-.362v-.828a.368.368 0 0 1 .106-.257.354.354 0 0 1 .256-.106zm2.871 0h.829a.364.364 0 0 1 .361.362v.83a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.367.367 0 0 1 .105-.257.369.369 0 0 1 .256-.106zm2.872 0h.828a.366.366 0 0 1 .364.361v.831a.366.366 0 0 1-.364.362h-.828a.362.362 0 0 1-.361-.362v-.828a.364.364 0 0 1 .361-.363zm-2.975-6.494h.828a.365.365 0 0 1 .362.361v.829a.36.36 0 0 1-.362.36h-.828a.362.362 0 0 1-.361-.36v-.829a.36.36 0 0 1 .361-.361zm2.871 0h.829a.364.364 0 0 1 .361.361v.829a.36.36 0 0 1-.361.36h-.829a.363.363 0 0 1-.363-.36v-.829a.366.366 0 0 1 .363-.361zm-76.636 4.155h.829a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.829a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .361-.36zm2.872 0h.828a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.828a.363.363 0 0 1-.362-.36v-.83a.363.363 0 0 1 .362-.36zm2.873 0h.828a.362.362 0 0 1 .362.36v.83a.362.362 0 0 1-.362.36h-.828a.363.363 0 0 1-.361-.36v-.83a.36.36 0 0 1 .361-.36zm2.872 0h.828a.362.362 0 0 1 .361.36v.83a.362.362 0 0 1-.361.36h-.828a.363.363 0 0 1-.364-.36v-.83a.365.365 0 0 1 .364-.36zm2.871 0h.829a.363.363 0 0 1 .363.36v.83a.363.363 0 0 1-.363.36h-.829a.363.363 0 0 1-.361-.36v-.83a.363.363 0 0 1 .361-.36zm-8.51 3.13h.827a.363.363 0 0 1 .362.362v.83a.363.363 0 0 1-.362.362h-.828a.362.362 0 0 1-.361-.362v-.828a.359.359 0 0 1 .361-.363zm2.87 0h.829a.363.363 0 0 1 .361.362v.83a.363.363 0 0 1-.361.362h-.828a.362.362 0 0 1-.362-.362v-.828a.362.362 0 0 1 .362-.363zm2.872 0h.829a.363.363 0 0 1 .363.362v.83a.364.364 0 0 1-.363.362h-.829a.363.363 0 0 1-.361-.362v-.828a.363.363 0 0 1 .361-.363zm-2.975-6.494h.828a.363.363 0 0 1 .362.361v.828a.362.362 0 0 1-.362.362h-.828a.363.363 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.363.363 0 0 1 .361.361v.828a.361.361 0 0 1-.361.362h-.828a.363.363 0 0 1-.364-.362v-.828a.366.366 0 0 1 .364-.361zm60.319 49.623h.829a.359.359 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.365.365 0 0 1 .362.361v.828a.365.365 0 0 1-.362.362h-.828a.365.365 0 0 1-.362-.362v-.828a.365.365 0 0 1 .362-.361zm2.873 0h.829a.364.364 0 0 1 .361.361v.828a.36.36 0 0 1-.361.362h-.829a.364.364 0 0 1-.361-.362v-.828a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .362.361v.828a.363.363 0 0 1-.362.362h-.828a.362.362 0 0 1-.363-.362v-.828a.364.364 0 0 1 .363-.361zm2.871 0h.829a.362.362 0 0 1 .363.361v.828a.367.367 0 0 1-.107.257.366.366 0 0 1-.256.105h-.829a.364.364 0 0 1-.361-.362v-.828a.364.364 0 0 1 .361-.361zm-8.511 3.131h.829a.364.364 0 0 1 .361.362v.83a.364.364 0 0 1-.361.36h-.829a.361.361 0 0 1-.361-.36v-.829a.367.367 0 0 1 .105-.257.362.362 0 0 1 .256-.106zm2.872 0h.828a.363.363 0 0 1 .361.362v.83a.36.36 0 0 1-.361.36h-.828a.365.365 0 0 1-.362-.361v-.828a.367.367 0 0 1 .105-.257.366.366 0 0 1 .257-.106zm2.871 0h.829a.362.362 0 0 1 .363.362v.83a.366.366 0 0 1-.363.36h-.829a.364.364 0 0 1-.361-.36v-.829a.362.362 0 0 1 .361-.363zm-2.975-6.495h.829a.364.364 0 0 1 .361.361v.829a.36.36 0 0 1-.361.361h-.829a.364.364 0 0 1-.361-.361V63.4a.36.36 0 0 1 .361-.361zm2.872 0h.828a.362.362 0 0 1 .362.361v.829a.365.365 0 0 1-.362.361h-.828a.362.362 0 0 1-.363-.361V63.4a.364.364 0 0 1 .363-.361z"
          fill="#EDEDED"
        />
        <path
          d="M117.748 49.274c-3.165.75-6.511-1.934-6.511-1.934s1.786-3.898 4.951-4.645c3.165-.75 6.51 1.932 6.51 1.932s-1.786 3.898-4.95 4.647z"
          fill="url(#5wwssswrhb)"
        />
        <path
          d="M21.572 50.685c-3.165.75-6.512-1.934-6.512-1.934s1.786-3.898 4.952-4.645c3.164-.75 6.51 1.932 6.51 1.932s-1.786 3.897-4.95 4.647z"
          fill="url(#ejf86g1m1c)"
        />
        <path
          d="M61.672 15.796c3.965-.801 6.348-5.576 6.348-5.576s-4.048-3.473-8.013-2.668c-3.965.802-6.348 5.574-6.348 5.574s4.048 3.472 8.013 2.67z"
          fill="url(#byfb6mf7ad)"
        />
        <path
          d="M94.237 82.156c5.023-1.154 7.897-7.315 7.897-7.315s-5.272-4.286-10.294-3.128c-5.023 1.154-7.896 7.31-7.896 7.31s5.271 4.287 10.293 3.133z"
          fill="url(#doj0t2tb2e)"
        />
        <path
          d="M125.239 56.13c-1.482 0-2.684 1.149-2.684 2.567 0 1.418 1.202 2.567 2.684 2.567 1.482 0 2.684-1.15 2.684-2.567 0-1.418-1.202-2.568-2.684-2.568zM47.057 76.974a2.337 2.337 0 1 0 0 4.673 2.337 2.337 0 0 0 0-4.673zM37.43 35.166a1.284 1.284 0 1 1 0-2.567 1.284 1.284 0 0 1 0 2.568zM122.55 27.005c-1.191 0-2.157-1.006-2.157-2.247 0-1.24.966-2.247 2.157-2.247 1.192 0 2.157 1.006 2.157 2.247 0 1.241-.965 2.247-2.157 2.247zM22.522 64.392a1.707 1.707 0 1 1 0-3.415 1.707 1.707 0 0 1 0 3.415z"
          fill="#FFAECD"
        />
        <path
          d="M62.88 78.88c-1.149 0-2.08-.895-2.08-2s.931-2 2.08-2 2.08.895 2.08 2-.931 2-2.08 2zM36.13 50.362a1.368 1.368 0 1 1 0-2.735 1.368 1.368 0 0 1 0 2.735zM75.28 84c-.663 0-1.2-.573-1.2-1.28 0-.707.537-1.28 1.2-1.28.663 0 1.2.573 1.2 1.28 0 .707-.537 1.28-1.2 1.28zM83.994 12.263a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334zM31.58 57.225a1.14 1.14 0 1 1-2.202.59 1.14 1.14 0 0 1 2.203-.59zM39.87 9.993a1.517 1.517 0 1 1 0-3.034 1.517 1.517 0 0 1 0 3.034zM115.417 35.257c-.644 0-1.167-.418-1.167-.933 0-.516.523-.934 1.167-.934.645 0 1.167.418 1.167.934 0 .515-.522.933-1.167.933zM97.578 17.002a2.373 2.373 0 1 1-4.585 1.229 2.373 2.373 0 0 1 4.585-1.229zM127.804 32.402h.031c.18 2.561 2.085 2.6 2.085 2.6s-2.1.041-2.1 3.001c0-2.96-2.101-3-2.101-3s1.904-.04 2.085-2.601zM26.884 21.526h.053c.311 4.483 3.592 4.552 3.592 4.552s-3.618.072-3.618 5.251c0-5.18-3.617-5.251-3.617-5.251s3.279-.07 3.59-4.552z"
          fill="#E1E4E5"
        />
      </g>
      <defs>
        <linearGradient
          id="5wwssswrhb"
          x1="114.71"
          y1="53.558"
          x2="118.137"
          y2="33.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="ejf86g1m1c"
          x1="18.534"
          y1="54.968"
          x2="21.96"
          y2="35.325"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="byfb6mf7ad"
          x1="58.011"
          y1="21.063"
          x2="62.218"
          y2="-3.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <linearGradient
          id="doj0t2tb2e"
          x1="89.456"
          y1="88.928"
          x2="94.873"
          y2="57.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#fff" />
          <stop offset="1" stop-color="#FFD8E7" />
        </linearGradient>
        <clipPath id="6n2uf8irga">
          <path fill="#fff" d="M0 0h144v96H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
